import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useGetDashboardLocationStatusPerOsVersionQuery } from '../../../api/dashboardApiSlice';
import BlockTabs from '../../BlockTabs';
import DevicePerOsVersion from '../../admin_dashboard/metrics/DevicePerOsVersion';
import DevicePerOsVersionEvolution from '../../admin_dashboard/metrics/DevicePerOsVersionEvolution';
import DevicePerSdkVersion from '../../admin_dashboard/metrics/DevicePerSdkVersion';
import DevicePerSdkVersionEvolution from '../../admin_dashboard/metrics/DevicePerSdkVersionEvolution';
import StackedBarChart from '../../charts/StackedBarChart';
import { Loader } from '../../components';
import SdkVersionTable from '../metrics/SdkVersionTable';
import { locationStatusDataToChartData } from '../../../services/data/charts/locationStatusDataToCharData';

const LocationStatusPerOsVersion = ({filter}) => {
  const { t } = useTranslation();
  const { data=[], isSuccess, isError, retry } = useGetDashboardLocationStatusPerOsVersionQuery({filter})
  const iosData = locationStatusDataToChartData("ios")(data)
  const androidData = locationStatusDataToChartData("android")(data)

  return (
    <BlockTabs title={t('version.location_status_per_os_version')} defaultActiveKey="android">
      <Loader success={true} error={false} minHeight={"100%"} key="ios" title="ios">
        <StackedBarChart data={iosData} />
      </Loader>
      <Loader success={true} error={false} minHeight={"100%"} key="android" title="android">
        <StackedBarChart data={androidData}/>
      </Loader>
    </BlockTabs>
  )
}

const AdminDashboardVersionTab = ({filter, setFilter}) => {
  const filterOnVersion = (version, os) => {
    setFilter({ ...filter, sdk_version: [version], os: [os] })
  }

  return (
    <>
      <SdkVersionTable filter={filter} onRowClick={(row)=> filterOnVersion(row.sdk_version, row.os)}/>
      <Row>
        <DevicePerSdkVersion filter={filter} as={Col} md={4}/>
        <DevicePerSdkVersionEvolution filter={filter} as={Col} md={8}/>
      </Row>
      <Row>
        <DevicePerOsVersion filter={filter} as={Col} md={4}/>
        <DevicePerOsVersionEvolution filter={filter} as={Col} md={8}/>
      </Row>
      <LocationStatusPerOsVersion filter={filter}/>
    </>
  )
}

export default AdminDashboardVersionTab
